




































































































import { to } from '@tencent/wphk-base-utils';
import { Component, Vue, Prop, Ref } from 'vue-property-decorator';
import { getCoupon, getCouponStateText, getCouponTips, getCouponValue } from './business';
import { CouponEntryReportInfo, CouponInfo, CouponState } from '../../type';
import { showDialog } from '@tencent/wphk-components-dialog';
import { i18n } from '../../i18n';
import { showLoading, hideLoading } from '@tencent/wphk-components-loading';
import CouponDetail from './detail.vue';
import CouponStamp from './stamp.vue';
import CouponBtn from './button.vue';
import { showToast } from '@tencent/wphk-components-toast';
import { getJumpPageABTestInfo } from '../../business';
import { goCouponDetail } from '../../business/coupon';
import { parseCurrencyAria, CouponAmount, getCurrencyCodeByType } from '@tencent/wphk-act-base-ui';
/**
 * 券展示单项
 * 主要功能：领取状态、领取、展示券详情、「NEW」标识
 */
@Component({
  components: {
    CouponDetail,
    CouponStamp,
    CouponBtn,
    CouponAmount,
  },
})
export default class WeCouponsCouponItem extends Vue {
  @Ref('detail') couponDetail!: CouponDetail;
  /**
   * 券信息
   */
  @Prop() public data!: CouponInfo;
  /**
   * 金额size设置
   */
  @Prop({ default: 48 }) public amountSize!: number;
  /**
   * 点击券是否展示详情
   */
  @Prop({ default: true }) public isDisplayDetail!: boolean;

  /**
   * 是否展示券状态印记
   */
  @Prop({ default: true }) public isDisplayStamp!: boolean;

  /**
   * 是否领取后是否立刻更新券状态
   */
  @Prop({ default: true }) public isUpdateState!: boolean;
  /**
   * 是否展示领取成功 toast，默认展示
   */
  @Prop({ default: true }) isShowSuccToast!: boolean;

  /** 是否点击无效 */
  @Prop({ default: false }) disabled?: boolean;

  /** 是否在详情点击领取后执行emit事件 */
  @Prop({ default: true }) notifyFromDetailAfterGetCoupon?: boolean;

  /** 是否在关闭详情后判断状态，如果是已领取则执行emit事件 */
  @Prop({ default: false }) notifyAfterGetCouponAndClose?: boolean;

  /** 当前组件所处的分类 */
  @Prop() classId?: string;
  /** 是否展示分享入口 */
  @Prop() isShowShare?: boolean;
  /** 券入口上报信息 */
  @Prop({ default: () => ({}) }) couponEntryReportInfo!: CouponEntryReportInfo;

  i18n = i18n;

  // 券数据
  couponInfo: CouponInfo | null = null;
  isShowDetail = false;

  /**
   * bi ext
   */
  get getBiExt() {
    const { col, row } = this.couponEntryReportInfo;
    return {
      frow: row,
      fcol: col,
      fclassid: this.classId,
      ...getJumpPageABTestInfo(),
    };
  }
  get couponEntry() {
    return this.couponEntryReportInfo.entry || 'default';
  }

  /**
   * 获取领取按钮信息
   */
  get state() {
    const state = this.couponInfo?.state || CouponState.Empty;
    return {
      desc: getCouponStateText(state),
      disable: state !== CouponState.Normal,
    };
  }

  get couponAriaLabel() {
    const { couponValue } = this;
    const amount = couponValue.isOff ? `${couponValue.value}${i18n('折')}` : `${getCurrencyCodeByType(this.couponInfo?.currencyType)}${couponValue.value}`;
    return parseCurrencyAria(`${this.spName} ${this.couponInfo?.couponName} ${amount}`, false, this.couponInfo?.currencyType);
  }

  /**
   * 获取券提示信息
   */
  get couponTips() {
    return getCouponTips(this.couponInfo!);
  }

  /**
   * 获取金额信息
   */
  get couponValue() {
    return getCouponValue(this.couponInfo!.couponValue);
  }

  /**
   * 商户logo
   */
  get spLogo() {
    return this.couponInfo?.merchantInfo.spLogo;
  }
  /**
   * 商户名
   */
  get spName() {
    return this.couponInfo?.merchantInfo.spName;
  }

  /**
   * 券点击
   */
  handleClick() {
    this.$emit('click');
    if (!this.isShowDetail && this.isDisplayDetail) {
      this.isShowDetail = true;
      setTimeout(() => {
        if (this.couponDetail) {
          this.couponDetail.show(this.couponInfo!);
        }
      }, 100);
    }
  }

  /**
   * 关闭详情
   */
  handleDetailClose() {
    this.isShowDetail = false;
    // emit通用关闭couponDetail事件
    this.notifyAction('closeCouponDetail', this.couponInfo);
    // 针对领取成功emit 领取成功且关闭couponDetail事件
    if (this.couponInfo?.state === CouponState.Got && this.notifyAfterGetCouponAndClose) {
      this.notifyAction('getSuccAndCloseCouponDetail', {
        err: null,
        result: {
          form: 'detailClose',
          couponId: this.couponInfo.couponId,
          recvState: 0,
          userScid: '',
        },
      });
    }
  }
  /** 弹窗中领取后进行emit */
  notifyActionHalfDialog(name, data) {
    if (!this.notifyFromDetailAfterGetCoupon) {
      return;
    }
    this.notifyAction(name, data);
  }
  /**
   * 详情中的按钮点击
   */
  handleDetailBtnClick() {
    this.handleBtnClick();
  }

  /**
   * 详情中的分享点击
   */
  handleDetailShareClick() {
    this.$emit('shareClick');
  }

  created() {
    this.couponInfo = this.data;
  }

  /**
   * 通知调用方领券结果
   */
  notifyAction(name: string, data) {
    this.$emit('action', { name, data });
  }

  /**
   * 领券
   */
  async getCoupon() {
    const spId = this.couponInfo?.merchantInfo?.spId || '';
    const couponId = this.couponInfo?.couponId || '';
    showLoading();
    const [err, result] = await to(getCoupon(spId, couponId));
    hideLoading();
    this.notifyAction('getCoupon', { err, result });
    if (err) {
      return showDialog({
        title: i18n('領取失敗，請稍候再試'),
      });
    }
    if (this.isShowSuccToast) {
      showToast({
        title: i18n('領取成功'),
        duration: 1000,
      });
    }
    // 领取成功，更新状态
    if (this.couponInfo && this.isUpdateState) {
      this.couponInfo.state = CouponState.Got;
      this.couponInfo.userScid = result?.userScid || '';
    }
  }

  /**
   * 点击券按钮
   */
  async handleBtnClick() {
    if (this.disabled) {
      return;
    }
    this.$emit('btnClick');
    switch (this.couponInfo?.state) {
      case CouponState.Normal:
        return await this.getCoupon();
      case CouponState.Got:
        goCouponDetail(this.couponInfo?.type, {
          userScid: this.couponInfo.userScid,
          adtag: 'discount-center',
        });
    }
  }
}
